'use client'

import { ActionIcon, Menu, Text } from '@mantine/core'
import styles from './index.module.css'

export type QuestionButtonValues = {
  text: string
  strong?: boolean
  link?: string
  openInNewWindow?: boolean
  action?: () => void
}

export function FloatingQuestionButton() {
  const QuestionButtonLinks: { [key: string]: QuestionButtonValues } = {
    fieldGuide: {
      text: 'Open Field Guide',
      strong: true,
      link: 'https://docs.google.com/presentation/d/1ONaiBxE3w4icuCrYLfHFL0Md-M6sKajEtVjgAbRIHqY/edit?usp=sharing',
      openInNewWindow: true,
    },
    helpDev: {
      text: 'Report a WP',
      link: 'https://bloomberg.enterprise.slack.com/archives/C14UDMHDL',
      openInNewWindow: true,
    },
    feedback: {
      text: 'Contact #help-tintin',
      link: 'https://bloomberg.enterprise.slack.com/archives/C09F5G0PY0K',
      openInNewWindow: true,
    },
  }

  return (
    <div className={styles['fab-container']} data-testid="fab-container">
      <Menu width={220} radius={'md'} position={'top-end'} trigger="hover">
        <Menu.Target>
          <ActionIcon radius={'xl'} size={40} className="button">
            ?
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {Object.entries(QuestionButtonLinks).map(([key, val]) => (
            <Menu.Item
              key={key}
              onClick={val.action ?? undefined}
              href={val.link ?? undefined}
              component={val.link ? 'a' : undefined}
              rel={val.link && val.openInNewWindow ? 'noopener noreferrer' : ''}
              target={val.link && val.openInNewWindow ? '_blank' : undefined}
            >
              <Text size={'sm'} fw={val.strong ? 700 : 400}>
                {val.text}
              </Text>
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </div>
  )
}
